module.exports = {"pagination":{"GetImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Images"},"ListFragments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fragments"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesis-video-archived-media-2017-09-30.paginators.json
// module id = 654
// module chunks = 2